import React, { useState, useEffect } from 'react';
import { GrDocumentUpdate } from 'react-icons/gr';
import { Link, useNavigate } from 'react-router-dom';
import { ContentHeader, DatePicker, Loader } from '@components';
import { UpdateCase, UpdateCaseFollowUp } from '@app/services/case';
import { Button, Modal, Form } from 'react-bootstrap';
import { getAllAdminName } from '../../services/leaves';
import { logoutUser } from '@store/reducers/auth';
import { getAllCases } from '@app/services/case';
import Pagination from '../../components/pagination/index';
import { endOfDay, startOfDay } from 'date-fns';
import { createActivity } from '@app/services/activity';
import handleStatus from '../../utils/ajax';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { boolean, object } from 'yup';
import { BASE_URL } from '../../config';
import { MdCases } from 'react-icons/md';

function ModalPopup({ handleClose, caseId, allCaseFn, userName }) {
  const [payload, setPayload] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const value = async (e) => {
    const changeDateFormat = e.target.value.split('-');
    const correctDateFormat =
      changeDateFormat[2] +
      '/' +
      changeDateFormat[1] +
      '/' +
      changeDateFormat[0];
    const payload = { followUpDate: correctDateFormat };
    setPayload(payload);
  };

  const UpdateCaseFn = async () => {
    if (Object.keys(payload).length === 0 || payload === undefined) {
      toast.error('Please Select a date');
    }
    if (Object.keys(payload).length > 0) {
      const resp = await UpdateCaseFollowUp(
        { ...payload, followUpRequire: true },
        caseId
      );
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp.status === 200) {
        const payload = {
          caseId: `${caseId}`,
          activityType: 'Comment',
          removeFollowUp: false,
          comment: `Follow up sent by ${userName}`
        };
        const create = await createActivity(payload);
        handleStatus(create.status, () => dispatch(logoutUser()), navigate);
        if (create.status === 200) {
          handleClose();
          toast.success('Case has been updated');
          allCaseFn();
        }
      }
    }
  };

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Follow Up</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-group w-60">
            <div className="col-md-12">
              <div className="form-group d-flex">
                <label htmlFor="datetimepicker2" className="col-md-5">
                  Request Follow Up:
                </label>
                <div className="input-group date" id="datetimepicker2">
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => value(e)}
                  />
                  <span className="input-group-addon">
                    <span className="glyphicon glyphicon-calendar"></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={UpdateCaseFn}>
            Follow Up
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function ModalPopup2({ handleClose, caseId }) {
  const [activityType, setActivityType] = useState('');
  const [comment, setComment] = useState('');
  const [disableFollowUp, setDisableFollowUp] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const checkBoxValue = async (e) => {
    if (e.target.checked) {
      setDisableFollowUp(true);
    }
  };

  const getActivityType = async (activity) => {
    setActivityType(activity);
  };

  const getComment = async (comment) => {
    setComment(comment);
  };
  const addActivity = async () => {
    if (
      activityType === null ||
      activityType === undefined ||
      activityType === ''
    ) {
      setActivityType('Comment');
    }

    if (comment === null || comment === undefined || comment === '') {
      toast.error('Please enter comment type');
    }

    if (comment && activityType) {
      const payload = {
        activityType: activityType,
        comment: comment,
        caseId: caseId,
        removeFollowUp: disableFollowUp
      };

      const resp = await createActivity(payload);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

      if (resp.status === 200) {
        toast.success('Activity has been added');
        handleClose();
      }
    }
  };

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-group w-60">
            <div className="form-group row form-form">
              <label htmlFor="inputSkills4" className="col-md-6 col-form-label">
                Activity Type
              </label>
              <div className="col-md-12">
                <select
                  className="form-control"
                  value={activityType}
                  onChange={(e) => getActivityType(e.target.value)}
                >
                  <option>Comment</option>
                  <option>Archive Cases</option>
                  <option>Follow up Sent</option>
                  <option>Follow up Request</option>
                </select>
              </div>
            </div>
            <div className="form-group row form-form">
              <label htmlFor="inputReason" className="col-md-6 col-form-label">
                Comment
              </label>
              <div className="col-md-12 ml-1">
                <textarea
                  className="form-control"
                  id="inputReason"
                  placeholder="Comment"
                  onChange={(e) => getComment(e.target.value)}
                  value={comment}
                ></textarea>
              </div>
            </div>
          </div>
          <Form.Check
            type={'checkbox'}
            label={` Disable FollowUp`}
            onChange={(e) => checkBoxValue(e)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={addActivity}>
            Add Activity
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const Reply = ({ value }) => {
  if (value === false) {
    return <span className="badge badge-danger">No</span>;
  }
  if (value === true) {
    return <span className="badge badge-success">Yes</span>;
  }
};

const Closed = ({ value }) => {
  if (value === false) {
    return <span className="badge badge-danger">No</span>;
  }
  if (value === true) {
    return <span className="badge badge-success">Yes</span>;
  }
};

const AllCases = () => {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState('');
  const [currentCase, setCurrentCase] = useState(null);
  const [title, setTitle] = useState('');
  const childRef = React.useRef();
  const [allCases, SetAllCases] = useState([]);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [selected, setSelected] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortBy, setSortBy] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userName = useSelector(
    (state: any) => state.auth.currentUser.data.name
  );

  const getAllCasesRecord = async (query) => {
    setShowLoader(true);
    const response = await getAllCases(query);
    handleStatus(response.status, () => dispatch(logoutUser()), navigate);

    if (response.data.ok === true) {
      SetAllCases(response.data.data);
      setTotalRecords(response.data.totalRecords);
    }
    setShowLoader(false);
  };

  const getAllAdmin = async () => {
    const res = await getAllAdminName();
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.data.ok) {
      setUsers(
        res.data.data.map((user) => ({ value: user._id, label: user.name }))
      );
    }
  };

  const handleChange = (e) => {
    childRef.current.resetDatePicker();
    if (e.target.value.toLowerCase() === 'today') {
      const todayStartDate = startOfDay(new Date());
      const todayEndDate = endOfDay(new Date());

      setStartDate(Date.parse(todayStartDate));
      setEndDate(Date.parse(todayEndDate));

      // getAll({ startDate:  Date.parse(todayStartDate) , endDate: Date.parse(todayEndDate)})
    } else if (e.target.value.toLowerCase() === 'yesterday') {
      const todayDate = Date.parse(new Date());

      const yesterDayDate = todayDate - 86400000;

      const yesterdayStartTime = startOfDay(new Date(yesterDayDate));
      const yesterdayEndTime = endOfDay(new Date(yesterDayDate));

      setStartDate(Date.parse(yesterdayStartTime));
      setEndDate(Date.parse(yesterdayEndTime));
    } else {
      setStartDate(0);
      setEndDate(0);
    }

    setSelected(e.target.value);
  };

  const changeHandler = (e) => {
    if (e.target.value == '') {
      setSortBy('');
      return;
    }

    setSortBy({ [e.target.value]: true });
  };

  const onChange = (e) => {
    let value = e.target.value;
    if (value === 'Name') {
      value = null;
    }
    setUser(value);
  };

  useEffect(() => {
    getAllAdmin();
    getAllCasesRecord({
      startDate: startDate,
      endDate: endDate,
      searchText: title,
      userId: user,
      pageNo: 1,
      ...sortBy
    });
  }, []);

  const handleCustomDateChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };


  const path = localStorage.getItem("Path");
  const pageNumber = localStorage.getItem("PageNo");

  useEffect(() => {
    if (path === "cases" && pageNumber !== 1) {
      setCurrentPage(pageNumber);
      getAllAdmin();
    getAllCasesRecord({
      startDate: startDate,
      endDate: endDate,
      searchText: title,
      userId: user,
      pageNo: pageNumber,
      ...sortBy
    });
    }
    else {
      localStorage.setItem("Path", 'cases');
      localStorage.setItem("PageNo", currentPage);
      getAllAdmin();
      getAllCasesRecord({
        startDate: startDate,
        endDate: endDate,
        searchText: title,
        userId: user,
        pageNo: 1,
        ...sortBy
      });
    }
  }, [])

  useEffect(() => {
    localStorage.setItem("PageNo", currentPage);
  }, [currentPage]);


  const paginate = async (pageno) => {
    getAllCasesRecord({
      startDate: startDate,
      endDate: endDate,
      searchText: title,
      userId: user,
      pageNo: pageno
    });

    setCurrentPage(pageno);

    //setCurrentPage(pageno);
  };

  const showPopup = (val) => {
    setShowModal(true);
    setCurrentCase(val._id);
  };
  const showPopup2 = (val) => {
    setShowModal2(true);
    setCurrentCase(val._id);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  const handleClose2 = () => {
    setShowModal2(false);
  };

  const filter = () => {
    getAllCasesRecord({
      startDate: startDate,
      endDate: endDate,
      searchText: title,
      userId: user,
      ...sortBy
    });
  };

  const reset = () => {
    setTitle('');
    setUser('');
    setSelected('');
    childRef.current.resetDatePicker();
    setStartDate(0);
    setEndDate(0);
    setSortBy('');
    getAllCasesRecord({});
  };

  return (
    <React.Fragment>
      <ContentHeader title="All Cases" />
      {showModal && (
        <ModalPopup
          handleClose={handleClose}
          caseId={currentCase}
          allCaseFn={getAllCasesRecord}
          userName={userName}
        />
      )}
      {showModal2 && (
        <ModalPopup2 handleClose={handleClose2} caseId={currentCase} />
      )}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">About Cases</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex align-items-baseline p-1">
                    <div className="containercase d-flex align-items-baseline justify-content-end right">
                      <div className="col-md-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Title"
                          onChange={(e) => setTitle(e.target.value)}
                          value={title}
                        />
                      </div>
                      <div className="col-md-2">
                        <select
                          onChange={onChange}
                          value={user}
                          className="form-control"
                        >
                          <option selected>Name</option>
                          {users.map((user, index) => (
                            <option key={index} value={user.value}>
                              {user.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <DatePicker
                            ref={childRef}
                            onSelect={handleCustomDateChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <select
                          className="form-control"
                          onChange={handleChange}
                          value={selected}
                        >
                          <option selected value="All">
                            All
                          </option>
                          <option value="Today">Today</option>
                          <option value="Yesterday">Yesterday</option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <select
                          onChange={changeHandler}
                          value={sortBy[0]}
                          className="form-control"
                        >
                          <option value="" selected>
                            All
                          </option>

                          <option value="reply">Reply</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                      <div className="col-md-1">
                        <Button variant="primary" onClick={filter}>
                          Search
                        </Button>
                      </div>
                      <div className="col-md-1 caseResetButton">
                        <Button variant="primary" onClick={reset}>
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body table-responsive p-0">
                    {showLoader ? (
                      <Loader title={'Daily'} />
                    ) : (
                      <table className="table table-striped projects">
                        <thead>
                          <tr>
                            <th
                              className="col-md-2"
                              style={{ paddingRight: '0px' }}
                            >
                              Client Name
                            </th>
                            <th
                              className="col-md-2"
                              style={{ width: '10%', paddingRight: '0px' }}
                            >
                              Link Open
                            </th>
                            <th className="col-md-1">Points</th>
                            <th className="col-md-2">Category</th>
                            <th className="col-md-1">Reply</th>
                            <th className="col-md-1">Closed</th>
                            <th
                              className="col-md-2"
                              style={{
                                width: '20%',
                                paddingRight: '0px',
                                paddingLeft: '0px',
                                textAlign: 'end'
                              }}
                            >
                              Action
                            </th>
                            <th
                              className="col-md-2"
                              style={{ width: '20%' }}
                            ></th>
                            <th
                              className="col-md-2"
                              style={{ width: '20%' }}
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {allCases &&
                            allCases.map((val, index) => {
                              // if(val.reply === false)
                              // {
                              //   val.reply = "No"
                              // }
                              // if(val.reply === true)
                              // {
                              //   val.reply = "Yes"
                              // }
                              // if(val.closed === false)
                              // {
                              //   val.closed = "No"
                              // }
                              // if(val.closed === true)
                              // {
                              //   val.closed = "Yes"
                              // }
                              return (
                                <>
                                  <tr key={index}>
                                    <td style={{ paddingRight: '0px' }}>
                                      {val.clientName}
                                    </td>
                                    <td style={{ paddingRight: '0px' }}>
                                      <a href={val.link} target="_blank">
                                        Open Link
                                      </a>
                                    </td>
                                    <td
                                      style={{
                                        paddingRight: '0px',
                                        textAlign: 'center'
                                      }}
                                    >
                                      {val.points}
                                    </td>
                                    <td>{val.category.category}</td>
                                    <td className="project_progress">
                                      <td>
                                        <Reply value={val.reply} />
                                      </td>
                                    </td>
                                    <td className="project-state">
                                      <td>
                                        <Closed value={val.closed} />
                                      </td>
                                    </td>
                                    <td className="project-actions">
                                      <button
                                        type="button"
                                        className="btn btn-primary button-of-cases"
                                        onClick={() => showPopup(val)}
                                      >
                                        Follow Up
                                      </button>
                                    </td>
                                    <td className="project-actions2">
                                      <button
                                        type="button"
                                        className="btn btn-primary button-of-cases"
                                        onClick={() => showPopup2(val)}
                                      >
                                        Add Activity
                                      </button>
                                    </td>
                                    <td className="case-actions">
                                      <Link
                                        to={'/view-activity/' + val._id}
                                        className="btn btn-primary btn-sm mr-2 button-of-cases"
                                      >
                                        <i className="fas fa-eye"></i>
                                      </Link>
                                      <Link
                                        to={'/update-case/' + val._id}
                                        className="btn btn-primary btn-sm mr-2"
                                      >
                                        <i className="fas fa-pencil-alt"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Pagination
              postsPerPage={postPerPage}
              totalPosts={totalRecords}
              paginate={paginate}
              currentPage={currentPage}
            ></Pagination>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AllCases;
